/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class SetListData implements IDirective {
        public controller = ["$scope", "treeItemService", "treeService", "workflowService", SetListDataController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/setListData.html';
        public restrict: string = "E";

        public scope: any = {
            setDataOperation: "=",
            processConfigId: "=",
        };

        public link(scope: ISetListDataScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: SetListDataController): void {
        }
    }

    export interface ISetListDataScope extends ng.IScope {
        setDataOperation: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto;
        processConfigId: string;

        sourceTreeItem: Wars.Domain.Model.TreeItem;
        destinationTreeItem: Wars.Domain.Model.TreeItem;

        onSourceDragOver($event: any): void;
        onSourceDrop($event: any): void;

        onDestinationDragOver($event: any): void;
        onDestinationDrop($event: any): void;

        getTreeItemDisplay(treeItem: Wars.Domain.Model.TreeItem): string;

        addSetDataOperation(): void;

        updateSourceList(name: string): void;
        updateDestinationList(name: string): void;
    }

    export class SetListDataController implements IController {

        private isSystemLevel: boolean;

        constructor(
            private $scope: ISetListDataScope,
            private treeItemService: services.TreeItemService,
            private treeService: services.TreeService,
            private workflowService: services.WorkflowService)
        {
            this.$scope.addSetDataOperation = () => this.addSetDataOperation();
        }

        private addSetDataOperation(): void {
            var newSetDataOperation = this.workflowService.createNewListDataOperation(this.$scope.setDataOperation);
        }
    }
}

warsApp.registerDirective('SetListData', []);